
const agenda = {
  ObtenerEventosCalendario: 'Forseti/Agenda/GetAudienciasCalendario',
  ObtenerDocumento: "Forseti/Agenda/ObtenerDocumento",
  GuardarAudiencia: "Forseti/Agenda/GuardarAudiencia",
  ObtenerAudiencia: "Forseti/Agenda/ObtenerAudiencia"
}

const audienciaspendientes = {
  ObtenSesionesDeLasAudienciasPendientes: 'Forseti/AudienciasPendientes/GetSesionesDeLasAudienciasPendientes',
  FinalizarSesionPorMedioDeHandyCam: 'Forseti/AudienciasPendientes/FinalizarSesionPorMedioDeHandyCam',
  ObtenSesionDeLaAudienciaPendiente: 'Forseti/AudienciasPendientes/GetSesionDeLaAudienciaPendiente',
  GuardarSesionDeLaAudiencia: 'Forseti/AudienciasPendientes/GuardarSesionDeLaAudiencia',
  GuardarCambioDeSala: 'Forseti/AudienciasPendientes/GuardarCambioDeSala',
  GuardarPruebasRealizadasyCreaRutasDeVideos: 'Forseti/AudienciasPendientes/GuardarPruebasRealizadasyCreaRutasDeVideos',
  EjecutarGrabacionDeSala: '/EmpezarGrabacionDeSala',
  EjecutarTransmisionAudio: '/IniciarTransmisionDeAudio', //Agregado para iniciar Tranmision de Audio en Audiencias por  Verificar y Grabacion
  TerminarTransmisionAudio: '/DetenerTransmisionDeAudio', // agregado para Detener la transmision de Audio en audiencias por verificar
  IniciarSesionDeLaAudiencia: 'Forseti/AudienciasPendientes/IniciarSesionDeLaAudiencia',
  GuardarMarcador: 'Forseti/AudienciasPendientes/GuardarMarcador',
  EjecutarFinalizacionDeGrabacionDeSala: '/FinalizarGrabacionDeSala',
  CambiarSalaYCrearUnaNuevaSesion: 'Forseti/AudienciasPendientes/CambiarSalaYCrearUnaNuevaSesion',
  FinalizarSesionDeLaAudiencia: 'Forseti/AudienciasPendientes/FinalizarSesionDeLaAudiencia',
  GenerarTokenYCrearZipDeLaAudiencia: 'Forseti/AudienciasPendientes/GenerarTokenYCrearZipDeLaAudiencia',
  CambiarEstatusCamaraDeSala:  'Forseti/AudienciasPendientes/CambiarEstatusCamaraDeSala',
  ObtenerAutoDeApertura:  'Forseti/AudienciasPendientes/ObtenerAutoDeApertura'
}

const audienciasPorVerificar = {
  ObtenAudienciasPorVerificar: 'Forseti/AudienciasPorVerificar/GetAudienciasPorVerificar',                                
  ObtenAudienciaPorVerificar: 'Forseti/AudienciasPorVerificar/GetAudienciaPorVerificar',
  CreaLosVideosDeLaSesionDeLaAudiencia: '/CreaLosVideosDeLaSesionDeLaAudiencia',
  GuardarPermisoEnAudienciaPorVerificar: 'Forseti/AudienciasPorVerificar/GuardarPermisoEnAudienciaPorVerificar',
  QuitararPermisoEnAudienciaPorVerificar: 'Forseti/AudienciasPorVerificar/QuitararPermisoEnAudienciaPorVerificar',
  FinalizarAudiencia: 'Forseti/AudienciasPorVerificar/FinalizarAudiencia',
  ObtenSesionDeLaAudienciaPorVerificar: 'Forseti/AudienciasPorVerificar/ObtenerSesionDeLaAudienciaAVerificar',
  GuardaLaCreacionLosVideosDeLaSesionDeLaAudiencia: 'Forseti/AudienciasPorVerificar/GuardaLaCreacionLosVideosDeLaSesionDeLaAudiencia',
  GuardarMarcador: 'Forseti/AudienciasPorVerificar/GuardarMarcador',
  GuardarVideo: 'Forseti/AudienciasPorVerificar/GuardarVideo',
  AgregarSesion: 'Forseti/AudienciasPorVerificar/AgregarSesion', 
  RealizarCopiaDeLosArchivosAlServidor: 'Forseti/AudienciasPorVerificar/RealizarCopiaDeLosArchivosAlServidor',
  RealizarCopiaDeLosArchivosAlMerge: 'Forseti/AudienciasPorVerificar/RealizarCopiaDeLosArchivosAlMerge' 
}

const audiencias = {
  agenda: agenda,
  audienciaspendientes: audienciaspendientes,
  audienciasPorVerificar: audienciasPorVerificar
}

export default audiencias;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/forseti/sistema/audiencias/audiencias.js
// module id = null
// module chunks = 